import React from "react";
import lodash from 'lodash'
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import { IconBack, IconClose, IconEdit } from "../../../icons/svg";
import { USER_PROFILE } from '../../../tinode/constants'
import TimeHelpers from "../../../lib/time";
import LetterTile from "../../letter-tile.jsx";

const messages = defineMessages({
  delete_message_popup: {
    id: 'delete_message_popup',
    defaultMessage: 'Delete messages',
    description: 'Alert dialog warning when delete message.'
  },
});

class SavedMessage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      savedMessage: [],
      showEditPopup: false,
    }

    this.handleEditMessage = this.handleEditMessage.bind(this)
    this.handleUnsaveMessage = this.handleUnsaveMessage.bind(this)
    this.handleShowPopupEdit = this.handleShowPopupEdit.bind(this)
    this.handleHidePopupEdit = this.handleHidePopupEdit.bind(this)
    this.handleOnClose = this.handleOnClose.bind(this)
    this.handleChangeEditField = this.handleChangeEditField.bind(this)

    this.renderContent = this.renderContent.bind(this)
  }

  componentDidMount() {
    this.props.tinode._db.mapSavedMessage((data) => {
      return data;
    }).then((data) => {
      const savedMessage = data.map((msg) => {
        const topic = this.props.tinode.getTopicByName(msg.topic)
        if (topic) {
          msg.name = lodash.has(topic, 'private.comment') ? topic.private.comment : topic.public.fn
          msg.avatar = lodash.has(topic, 'public.photo.ref') ? topic.public.photo.ref : undefined
          let body = msg.content
          if (lodash.has(msg, 'content.txt')) {
            body = msg.content.txt.substring(msg.content.txt.indexOf(' '))
          }
          msg.body = body
        }
        return msg
      }).reverse()
      this.setState({ savedMessage })
    })
  }

  handleOnClose(e) {
    if (this.state.showEditPopup) {
      this.handleHidePopupEdit(e)
    } else {
      this.props.handleShowSettingHome(e)
    }
  }

  handleShowPopupEdit(e, message) {
    e.preventDefault();
    this.setState({
      showEditPopup: true,
      editSavedTime: message.savedTime,
      editBody: message.body,
      newBody: message.body,
    })
  }

  handleHidePopupEdit(e) {
    e.preventDefault();
    this.setState({
      showEditPopup: false,
      editSavedTime: null,
      editBody: '',
      newBody: ''
    })
  }

  handleChangeEditField(e) {
    this.setState({
      newBody: e.target.value,
    })
  }

  handleEditMessage(e) {
    const savedTime = this.state.editSavedTime
    const newBody = this.state.newBody

    const savedMessage = this.state.savedMessage.map((msg) => {
      if (msg.savedTime === savedTime) {
        msg.content = newBody
        msg.body = newBody
        this.props.tinode._db.updSavedMessage(msg)
      }
      return msg
    })

    this.setState({
      savedMessage
    })
    this.handleHidePopupEdit(e)
  }

  handleUnsaveMessage(savedTime, body) {
    const { formatMessage } = this.props.intl;
    this.props.onShowAlert(
      formatMessage(messages.delete_message_popup), // title
      body, // content
      (_ => {
        this.props.tinode._db.remSavedMessage(savedTime)
        const savedMessage = this.state.savedMessage.filter(msg => msg.savedTime !== savedTime)
        this.setState({
          savedMessage
        })
      }), // onConfirm
      null, // "OK"
      true, // Show Reject button
      null  // "Cancel"
    )
  }

  renderContent() {
    if (this.state.showEditPopup) {
      return (
        <div className="edit-saved-message-container">
          <div className="edit-msg-old-content">
            <div className="icon mr-4" onClick={this.handleOnClose}>
              <IconEdit />
            </div>
            <div className="old-content">{this.state.editBody}</div>
          </div>

          <div className='edit-input-container'>
            <textarea
              className='edit-input'
              id='edit-saved-message-input'
              type="text"
              onChange={this.handleChangeEditField}
              value={this.state.newBody}
              autofocus
            />
          </div>
          <div className='edit-button-container'>
            <button className="btn-cancel edit-button" onClick={this.handleOnClose}>
              <FormattedMessage id="button_cancel" defaultMessage={"Cancel"} />
            </button>
            <button className="btn-ok edit-button" onClick={this.handleEditMessage}>
              <FormattedMessage id="button_edit" defaultMessage={"Edit"} />
            </button>
          </div>

        </div>
      )
    } else {
      return (
        <div className="list-saved-messages">
          {
            this.state.savedMessage.map((message) => {
              return (
                <div className='saved-message-container' key={message.savedTime}>
                  <div className="avatar-container">
                    <div className="avatar">
                      <LetterTile
                        tinode={this.props.tinode}
                        avatar={message.avatar || true}
                        topic={message.topic}
                        title={message.name}
                      />
                    </div>
                  </div>
                  <div className="msg-content-container">
                    <div className="msg-header">
                      <div
                        className="msg-title"
                        onClick={(e) => this.handleShowPopupEdit(e, message)}
                      >
                        <div className="msg-title-name">{message.name}</div>
                        <div className="msg-time">{TimeHelpers.convertDDMMYYYYHHmmFormat(new Date(Number(message.savedTime)), '/', ':')}</div>
                      </div>
                      <button
                        className="btn-ok msg-unsave-btn"
                        onClick={() => {
                          this.handleUnsaveMessage(message.savedTime, message.body)
                        }}
                      >
                        <FormattedMessage id="dialog_unsave_button" defaultMessage={"Unsave"} />
                      </button>
                    </div>

                    <div
                      onClick={(e) => this.handleShowPopupEdit(e, message)}
                      className="msg-content"
                    >{message.body}</div>
                  </div>
                </div>
              )
            })
          }
        </div>)
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="header">
          <div className="title dialog-flex-center">
            <div className="icon mr-4" onClick={this.handleOnClose}>
              <IconBack />
            </div>
            {this.state.showEditPopup ? <FormattedMessage id="dialog_edit_saved_message" defaultMessage={"Edit saved messages"} /> :
              <FormattedMessage id="dialog_saved_message" defaultMessage={"Saved messages"} />
            }
          </div>
          <div className="icon" onClick={this.props.onClose}><IconClose /></div>
        </div>
        {this.renderContent()}
      </React.Fragment>
    )
  }
}

export default injectIntl(SavedMessage)
